export const TextEditorUnderline = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8 12.5C10.3 12.5 12.1667 10.54 12.1667 8.125V2H10.0833V8.125C10.0833 9.3325 9.15 10.3125 8 10.3125C6.85 10.3125 5.91667 9.3325 5.91667 8.125V2H3.83333V8.125C3.83333 10.54 5.7 12.5 8 12.5ZM3 14.25V16H13V14.25H3Z'
      fill='#334155'
    />
  </svg>
);
